var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0029 16.6339L21.504 19.135",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.504 16.6339L19.0029 19.135",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0002 12.0671V8.99878",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0002 15.6775C12.9574 15.6775 12.9164 15.6946 12.8863 15.7251C12.8562 15.7555 12.8396 15.7968 12.8401 15.8396C12.8407 15.9281 12.9117 16 13.0002 16.0016C13.0897 16.0016 13.1623 15.9291 13.1623 15.8396C13.1623 15.7501 13.0897 15.6775 13.0002 15.6775",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0501 13.5187L16.3212 5.39727C15.6313 4.21768 14.3673 3.49268 13.0008 3.49268C11.6343 3.49268 10.3703 4.21768 9.68041 5.39727L3.97803 15.1793C3.3391 16.2785 3.33798 17.6357 3.97512 18.7359C4.61225 19.8361 5.78997 20.5107 7.06131 20.5036H16.0381",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.20ba125bd202e0f34abfe76725efd97b.svg";
export { ForwardRef as ReactComponent };